import React from "react";
import { AlertTriangle } from "lucide-react";
import { configuredLine, hoursText, percentText } from "../../lib/portalAttendance";
import { Chip } from "./PortalShell";

/**
 * The asynchronous hours of one group: who has how many, who is under the
 * threshold, and what is missing. The same table for the trainer and the team;
 * `actions` puts per-row buttons on the right (the team's PDF per participant).
 * `settled` — the course is over: until then nobody is "under the threshold"
 * yet, the hours are progress, not a verdict (06.10.2026).
 */
export default function AttendanceTable({ report, onOpen, actions, settled = true }) {
  if (!report) return null;
  const below = (p) => settled && p.below;
  return (
    <div data-testid="portal-attendance">
      <p className="text-sm text-[#6B7280]">
        {configuredLine(report)} · prag {report.threshold}%
        {settled && ` · ${report.below_count === 0 ? "nimeni sub prag" : report.below_count === 1 ? "un cursant sub prag" : `${report.below_count} cursanți sub prag`}`}
      </p>
      {report.warnings.map((w) => (
        <p key={w} className="mt-2 flex gap-2 rounded-xl bg-[#d99a2b]/10 px-3 py-2 text-sm text-[#8a5d12]">
          <AlertTriangle size={15} className="mt-0.5 shrink-0" /> {w}
        </p>
      ))}
      {report.activities.length > 0 && report.participants.length > 0 && (
        <div className="mt-3 overflow-x-auto rounded-2xl border border-[#E5E7EB] bg-white">
          <table className="w-full min-w-[36rem] text-sm">
            <thead>
              <tr className="border-b border-[#E5E7EB] text-left text-xs text-[#6B7280]">
                <th className="px-4 py-2.5 font-semibold">Cursant</th>
                <th className="px-3 py-2.5 font-semibold">Ore</th>
                <th className="px-3 py-2.5 font-semibold">Procent</th>
                <th className="px-3 py-2.5 font-semibold">Ce lipsește</th>
                {actions && <th className="px-4 py-2.5" />}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E5E7EB]">
              {report.participants.map((p) => (
                <tr key={p.enrollment_id} className={below(p) ? "bg-[#c0483f]/[0.04]" : ""}>
                  <td className="px-4 py-2.5 font-semibold">
                    {onOpen
                      ? <button type="button" onClick={() => onOpen(p.enrollment_id)} className="text-left hover:text-[#965EA7]">{p.name}</button>
                      : p.name}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 tabular-nums">{hoursText(p.done_hours)}</td>
                  <td className="whitespace-nowrap px-3 py-2.5">
                    <Chip tone={below(p) ? "late" : settled ? "good" : "neutral"}>{percentText(p.percent)}{below(p) ? " · sub prag" : ""}</Chip>
                  </td>
                  <td className="px-3 py-2.5 text-xs text-[#6B7280]">{p.missing.length ? p.missing.join("; ") : "—"}</td>
                  {actions && <td className="px-4 py-2.5 text-right">{actions(p)}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
